import { useState, useEffect } from "react";
import "./EditPersonalInformation.css";
import profile from "../../../../../../assets/settings-profile.png";
import countriesData from "../../../../../../data/countries.json";
import pen from "../../../../../../assets/pen.png";

const EditPersonalInformation = ({ setActive }) => {
 const [fullname, setFullname] = useState("");

 const [phone, setPhone] = useState("");
 const [email, setEmail] = useState("");
 const [country, setCountry] = useState("");
 const [states, setStates] = useState("");
 const [stateOfOrigin, setStateOfOrigin] = useState();

 useEffect(() => {
  const i = countriesData.filter((item) => item.name === country);

  if (Boolean(i.length > 0)) {
   setStates(i[0]);
  } else {
   return;
  }
 }, [country]);

 return (
  <div className="edit-personal-information">
   <div className="profile">
    <div className="img-container">
     <img src={profile} alt="profile" />
     <div className="pen-container">
      <img src={pen} alt="pen" />
      <p style={{ textDecoration: "underline" }}>Change photo</p>
     </div>
    </div>
    <div className="name-container">
     <a href="/">Edit</a>
    </div>
   </div>

   <div>
    {" "}
    <form action="">
     <div className="form-container">
      <div className="input-container">
       <label htmlFor="fullname">Full name</label>
       <input
        type="text"
        id="fullname"
        placeholder="Enter full name"
        value={fullname}
        onChange={(e) => setFullname(e.target.value)}
       />
      </div>

      <div className="input-container">
       <label htmlFor="email">Email</label>
       <input
        type="email"
        id="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
       />
      </div>

      <div className="input-container">
       <label htmlFor="phone">Phone number</label>
       <input
        type="text"
        id="phone"
        placeholder="234 7035345753"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
       />
      </div>

      <div className="flex">
       <div className="input-container">
        <label htmlFor="country">Country</label>
        <select
         id="country"
         defaultValue={"Select country"}
         onChange={(e) => {
          setCountry(e.target.value);
         }}
        >
         <option default disabled>
          Select country
         </option>

         {countriesData.map((data, index) => {
          return (
           <option key={index} data-index="index" value={data.name}>
            {data.name}
           </option>
          );
         })}
        </select>
       </div>

       <div className="input-container">
        <label htmlFor="state">State</label>
        <select
         id="state"
         value={stateOfOrigin}
         onChange={(e) => setStateOfOrigin(e.target.value)}
        >
         <option default defaultValue={"Select state"} selected disabled>
          Select state
         </option>

         {states &&
          states.states.length > 0 &&
          states.states.map((data, index) => (
           <option key={index} value={data}>
            {data}
           </option>
          ))}
         {states && states.states.length === 0 && (
          <option key={states.name} value={states.name}>
           {states.name}
          </option>
         )}
        </select>
       </div>
      </div>
     </div>
    </form>
   </div>

   <div className="shapBtn-container">
    <p onClick={() => setActive("personalinformation")}>Cancel</p>
    <p className="shapBtn">Save</p>
   </div>
  </div>
 );
};

export default EditPersonalInformation;
